export default {
  SMS_CONFIRMATION_PAGE_TITLE: 'SMS-tunnistautuminen',
  SMS_CONFIRMATION_SUCCESS_FLASH_TITLE: 'Kiitos, tunnistautuminen onnistui.',
  SMS_CONFIRMATION_SUCCESS_FLASH_BODY:
    'Tunnistautuminen on onnistunut. Nyt voit sulkea tämän sivun ja jatkaa keskustelua chatissa asiakaspalvelumme kanssa.'
}
